function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 127 127"
}, props), React.createElement("circle", {
  cx: "63.5",
  cy: "63.5",
  r: "61.5",
  fill: "#fff",
  stroke: "#77CAF1",
  strokeWidth: "4",
  strokeDasharray: "8 8"
}), React.createElement("ellipse", {
  cx: "62.803",
  cy: "85.716",
  rx: "46.803",
  ry: "10.284",
  fill: "#B2DAEE"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.508 80.165c.195-.002 8.424-.027 9.178-.025-.002.17-.025.352-.041.521-.069.76-.179 1.523-.35 2.262l-.005.017c-.342 1.457-.944 2.847-1.907 4.002a8.48 8.48 0 01-.627.684c-.896.267-2.627.279-3.271 0a8.244 8.244 0 01-1.023-1.176c-.767-1.073-1.272-2.317-1.565-3.599-.21-.89-.307-1.78-.39-2.686z",
  fill: "url(#paint0_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.823 60.95a14.519 14.519 0 00-1.612 2.273c.136.244.257.495.395.742a7.389 7.389 0 00-.649-.264c-1.166 2.327-1.152 4.437-.347 6.315.633.27.8.31 1.59.395l-1.146.483c1.006 1.712 2.798 2.593 2.252 5.319a8.469 8.469 0 00-.06.32l1.405.907c-.733-.049-1.016-.053-1.484.037.04 1.268.818 2.604 4.228 3.834.332-.027 1.153-.427 1.325-.664-.15-1.182.204-3.25.508-4.876.247-1.322.164-2.25-.13-2.963-.424.21-.862.36-1.297.552.35-.625.522-.93.66-1.543-1.07-1.174-2.851-1.779-4.08-3.73a15.71 15.71 0 01-.226-.372c-.24.103-.483.193-.725.3.198-.355.323-.574.417-.853-.8-1.516-1.536-3.656-1.024-6.212z",
  fill: "url(#paint1_linear_4950_6652)"
}), React.createElement("path", {
  opacity: ".5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.167 73.95c.236.609.324 1.327.137 2.262-.02.106-.042.213-.06.32.468.303.936.606 1.404.907-.733-.049-1.016-.053-1.484.037.041 1.268.819 2.604 4.228 3.834.332-.026 1.153-.427 1.325-.664-.15-1.182.204-3.25.508-4.876.247-1.322.164-2.25-.13-2.964-.424.21-.862.361-1.297.553.35-.625.522-.93.66-1.543-.675-.742-1.633-1.255-2.558-2.023-.476 1.586-1.855 2.566-2.733 4.157z",
  fill: "url(#paint2_linear_4950_6652)"
}), React.createElement("path", {
  opacity: ".5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.42 69.605c-.544-.224-1.327-.804-1.795-1.362.557.354 1.02.718 1.545.907a5.6 5.6 0 01-.258-.602c-.687-1.9-.254-3.585.282-5.405-.356 1.445-.663 2.82-.379 4.252.135-.446.412-.783.775-1.316-.279.65-.584 1.214-.628 1.892.05.162.11.324.177.488.345.832.865 1.493 1.433 2.1-.059-.581.113-1.07.363-1.742-.104.629-.213 1.393-.069 2.048.787.803 1.62 1.54 2.175 2.506.288-1.238.216-1.013.497-2.236.095 1.34.051 1.85-.224 2.79.168.4.287.843.34 1.341.134 1.247.126 2.023.204 2.695.7-1.415.378-.75 1.316-2.76-.088 1.172-.05 1.302-1.155 3.583.177.602.512 1.248 1.184 2.23a3.42 3.42 0 01-.646.265c-1.227-1.831-1.23-2.541-1.25-3.917-.534-.933-1.212-1.989-1.938-2.696.663.251 1.186.628 1.91 1.74a19.603 19.603 0 00-.084-1.11c-.117-1.109-.644-1.951-1.301-2.736-1.279-.527-1.545-.52-2.121-.669.735-.077 1.185-.025 1.626.11-.682-.743-1.425-1.48-1.98-2.396z",
  fill: "url(#paint3_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.654 52.344c-1.26.672-2.34 1.385-3.257 2.13.053.387.082.773.135 1.165-.283-.286-.49-.495-.709-.676-2.706 2.426-3.765 5.176-3.68 8.029.683.675.882.81 1.864 1.326l-1.738.04c.433 2.742 2.31 4.801.207 8.064-.082.127-.163.255-.242.385l1.36 1.896c-.928-.438-1.291-.588-1.946-.711-.595 1.669-.268 3.802 3.534 7.144.445.135 1.718.034 2.061-.184.409-1.612 1.929-4.12 3.153-6.077.997-1.592 1.364-2.84 1.346-3.917-.658.056-1.305.03-1.967.054.776-.633 1.154-.941 1.645-1.667-.79-2.074-2.797-3.77-3.394-6.934-.035-.19-.071-.39-.104-.6-.364.013-.726.005-1.097.02.44-.36.713-.583.978-.896-.26-2.374-.122-5.53 1.851-8.59z",
  fill: "url(#paint4_linear_4950_6652)"
}), React.createElement("path", {
  opacity: ".5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.705 63.383c-.593-.569-1.312-1.722-1.635-2.687.543.744.958 1.454 1.544 1.969a7.992 7.992 0 01-.028-.913c.08-2.82 1.502-4.788 3.129-6.878-1.201 1.697-2.304 3.327-2.665 5.332.405-.51.935-.806 1.68-1.313-.695.7-1.38 1.279-1.783 2.137a8.116 8.116 0 00-.02.724c.024 1.257.361 2.383.788 3.46.221-.785.695-1.334 1.362-2.078-.456.764-.988 1.702-1.137 2.627.612 1.446 1.316 2.829 1.543 4.368 1.008-1.46.8-1.204 1.791-2.651-.56 1.788-.878 2.43-1.718 3.511a6.68 6.68 0 01-.243 1.916c-.464 1.69-.872 2.693-1.114 3.607 1.632-1.481.874-.782 3.121-2.914-.712 1.479-.73 1.665-3.331 4.066-.078.872.026 1.883.398 3.503a4.769 4.769 0 01-.975.014c-.657-3.006-.297-3.931.377-5.729-.215-1.485-.556-3.204-1.138-4.495.732.667 1.22 1.423 1.593 3.239.148-.435.302-.922.457-1.485.413-1.502.16-2.866-.293-4.221-1.391-1.34-1.74-1.468-2.415-1.955.995.276 1.553.574 2.058.975-.506-1.318-1.096-2.655-1.346-4.13z",
  fill: "url(#paint5_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.578 79.676h9.035c.22 0 .402.181.402.402v.825c0 .221-.181.403-.402.403h-9.035a.404.404 0 01-.402-.403v-.825a.402.402 0 01.402-.402z",
  fill: "url(#paint6_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.491 69.082l-3.67 18.944h1.72l3.815-18.944H64.49z",
  fill: "#A7A4A4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.86 69.082l-3.681 18.944h1.495L65.5 69.082h-1.64zM77.795 69.082l3.67 18.944h-1.72L75.93 69.082h1.865z",
  fill: "#BDBDBD"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.635 69.082l3.681 18.944h-1.495l-3.826-18.944h1.64z",
  fill: "#A7A4A4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.131 69.082l3.67 18.944h-1.72l-3.815-18.944h1.865z",
  fill: "#BDBDBD"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.76 69.082l3.681 18.944h-1.495L59.12 69.082h1.64zM46.612 69.082l-3.67 18.944h1.72l3.815-18.944h-1.865z",
  fill: "#A7A4A4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.985 69.082l-3.681 18.944h1.495l3.826-18.944h-1.64zM46.352 67.805l.843-.34c-1.517-3.901-3.136-12.769-3.152-12.858l-.892.169c.067.367 1.651 9.044 3.201 13.029zM65.086 67.379l.844-.346c-1.518-3.963-3.137-12.974-3.153-13.064l-.892.17c.067.374 1.652 9.191 3.201 13.24z",
  fill: "#BDBDBD"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.993 67.805l.843-.34c-1.517-3.901-3.136-12.769-3.152-12.858l-.892.169c.066.367 1.651 9.044 3.2 13.029zM65.723 67.379l.843-.346c-1.517-3.963-3.136-12.974-3.152-13.064l-.892.17c.067.374 1.652 9.191 3.201 13.24z",
  fill: "#A7A4A4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.679 69.508H58.265v-2.341h22.137v.655c0 .931-.771 1.686-1.723 1.686z",
  fill: "#DBDAD8"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.953 69.508h11.313v-2.341H44.643v.082c0 1.248 1.034 2.259 2.31 2.259zM58.51 37.987l3.352 15.508a1.059 1.059 0 01-1.008 1.282l-18.942.468a1.059 1.059 0 01-1.061-.837l-3.42-15.976a1.059 1.059 0 011.036-1.28h19.01c.498 0 .929.348 1.034.835z",
  fill: "#DBDAD8"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.97 37.987l3.38 15.508a1.06 1.06 0 01-1.017 1.282l-19.106.468a1.066 1.066 0 01-1.07-.837l-3.45-15.976a1.061 1.061 0 011.044-1.28h19.175c.503 0 .938.348 1.044.835z",
  fill: "#A7A4A4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.52 29.7s-2.102-2.302-4.254-1.548c-2.152.754-4.451 2.405-4.583 6.407-.122 3.687-2.55 6.175-4.467 8.169-1.916 1.994-2.718 9.029 7.676 9.286 10.394.256 8.685-5.54 7.767-8.414-.918-2.874-.965-6.967.184-8.76 1.15-1.795-.383-5.376-2.323-5.14z",
  fill: "#1D1F29"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.824 66.144l-2.337 6.186-3.05 8.078s-.829.078-1.622-.146c-.73-.208-1.567-.75-1.567-.75s.634-8.674 2.214-13.653c.405-1.277 1.072-2.311 1.573-2.893 2.45-2.849 4.79 3.178 4.79 3.178z",
  fill: "url(#paint7_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.96 57.425c-1.53-.486-5.484-.109-9.795-.124l-.918-1.49-9.475-.728s-2.508 3.555-1.694 9.074c.288 1.953 1.894 3.015 3.49 3.015 1.11 0 4.833.137 6.664.137 4.712 0 8.758-2.37 9.406-2.615.603-.228 2.785 2.982 4.335 5.025 2.594 3.421 9.507 9.23 9.507 9.23s1.323-.483 1.917-.703c.639-.235.872-.541.872-.541S81.413 58.52 77.962 57.425z",
  fill: "url(#paint8_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.79 37.487s-.24.81-.402 1.841c-2.071-.788-2.753-1.693-3.03-2.742l3.431.9z",
  fill: "#DD7855"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.835 38.759S60.402 37.72 61.1 34.9c.699-2.82.83-4.809 3.809-4.268 2.979.54 3.283 1.753 3.282 2.75 0 .997-1.669 5.86-3.356 5.376z",
  fill: "#EE8A68"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.824 31.488s-2.638 2.935-4.3 2.605c-2.015-.4-2.41-.685-2.41-.685s1.291-.873 2.159-2.391a1.442 1.442 0 011.256-.725c1.465.006 2.888-.119 3.295 1.196z",
  fill: "#1D1F29"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.314 48.223c-1.093 5.688-.31 7.934-1.078 8.282-.301.137-.955.341-1.882.402-2.914.19-8.037-.282-8.231-.812-.673-1.834-.198-2.403-.759-5.21a23.26 23.26 0 00-.216-.973c-.467-1.928-.922-2.583.737-5.68 1.504-2.805 3.067-5.082 3.207-5 1.489.87 3.08 3.505 3.7 3.361.658-.153.59-2.991.59-2.991s4.794 4.14 3.932 8.62z",
  fill: "url(#paint9_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.488 72.33l-3.235 8.882s-.735-.175-1.528-.4c-.73-.207-1.568-.75-1.568-.75s.726-9.224 2.306-14.203l4.025 6.47z",
  fill: "url(#paint10_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.377 39.601s4.192 1.07 4.672 2.8l3.193 11.51s-1.816 1.63-2.775.687c-.959-.943-3.597-10.017-3.597-10.017l-1.493-4.98z",
  fill: "url(#paint11_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.824 56.738c-3.017.597-9.504-.114-9.699-.643-.672-1.834-.198-2.403-.758-5.21l2.103-3.562s-2.047 4.301-.747 5.442c1.299 1.14 6.438 1.904 7.07 2.857.305.458 1.973.748 2.031 1.116z",
  fill: "#0386A9"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.933 54.987s1.712-.2 2.802-.365c1.09-.165 2.383.578 2.718.86.336.283-.18.613-.503.306 0 0 .672.258.527.448-.145.19-.73.142-.994-.082 0 0 .431.165.276.33-.156.164-.563.259-.886 0-.324-.26-.958-.59-1.377-.354-.42.236-2.311.514-2.311.514s.153-.56-.252-1.657z",
  fill: "#EE8A68"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.09 39.23s-3.443.25-4.78 2.084c-1.88 2.581-5.795 13.345-3.656 14.812 2.409 1.652 10.727.652 10.727.652s.184-1.39.185-1.867c.002-.58-6.729-1.55-7.08-2.068-.233-.344 3.368-5.653 3.368-6.53 0-.876 1.236-7.083 1.236-7.083z",
  fill: "url(#paint12_linear_4950_6652)"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.633 78.781s-.399-.047-1.022-1.298l-2.072 1.163s.585 1.415.981 2.126l2.113-1.99z",
  fill: "#EE8A68"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.18 80.192s1.118-.177 2.205-1.605c0 0 1.43-.136 2.685-.106a6.164 6.164 0 001.606-.203 1.25 1.25 0 011.39.576l.13.223a.345.345 0 01-.132.474l-6.394 3.59a.356.356 0 01-.482-.13l-.401-.691s-.584-.89-.607-2.128z",
  fill: "#026580"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.141 79.506l-6.551 3.679a.265.265 0 01-.358-.097l-.184-.316 7.007-3.935.184.317a.256.256 0 01-.098.352z",
  fill: "#DADADA"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.992 79.316a.093.093 0 01-.088-.097l.037-.683a.094.094 0 01.1-.088.093.093 0 01.088.098l-.038.683a.094.094 0 01-.099.087zM93.477 79.295a.093.093 0 01-.089-.097l.038-.683a.094.094 0 01.099-.088.093.093 0 01.088.098l-.038.683a.094.094 0 01-.098.087zM93.992 79.266a.093.093 0 01-.088-.097l.037-.683a.093.093 0 01.1-.087.093.093 0 01.088.097l-.038.683a.094.094 0 01-.099.087zM94.531 79.252a.093.093 0 01-.088-.097l.037-.683a.094.094 0 01.1-.088.093.093 0 01.088.098l-.038.683a.094.094 0 01-.099.087zM95.07 79.172a.093.093 0 01-.088-.098l.037-.683a.094.094 0 01.1-.087.093.093 0 01.088.097l-.038.683a.094.094 0 01-.099.088zM90.273 81.005s.612.032 1.41 1.41l-.636.357s-.596-.825-.773-1.767zM91.25 79.917a3.77 3.77 0 01-.978.379.13.13 0 11-.062-.254c1.539-.366 2.082-1.517 2.087-1.529a.134.134 0 01.175-.065.13.13 0 01.067.172c-.018.04-.367.78-1.289 1.297z",
  fill: "#013B4C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.392 77.838l-2.821 1.584a.255.255 0 01-.346-.093l-.34-.586a.247.247 0 01.095-.34l2.82-1.584a.255.255 0 01.346.093l.34.587c.07.12.027.271-.094.34z",
  fill: "#027A9A"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.412 82.892s-.01-.775.623-1.882l-2.632-.847s-.036 1.048-.783 1.872l2.792.857z",
  fill: "#EE8A68"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.97 81.461s.698.877 2.494 1.124c0 0 .811 1.166 1.391 2.26.268.505.637.952.957 1.287.384.402.451 1.004.16 1.475l-.137.22a.357.357 0 01-.485.115l-6.284-3.772a.345.345 0 01-.118-.478l.422-.68s.51-.933 1.6-1.55z",
  fill: "#026580"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.43 87.988l-6.439-3.865a.256.256 0 01-.087-.355l.193-.311 6.887 4.134-.193.311a.265.265 0 01-.36.086z",
  fill: "#DADADA"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74.363 83.867a.092.092 0 01.044-.123l.626-.298a.095.095 0 01.126.043.092.092 0 01-.044.123l-.626.298a.095.095 0 01-.126-.043zM74.64 84.3a.092.092 0 01.044-.123l.627-.298a.095.095 0 01.125.043.092.092 0 01-.044.123l-.626.298a.095.095 0 01-.125-.043zM74.91 84.757a.092.092 0 01.044-.124l.626-.297a.095.095 0 01.126.043.092.092 0 01-.044.123l-.627.298a.095.095 0 01-.125-.043zM75.242 85.18a.092.092 0 01.044-.123l.626-.298a.095.095 0 01.126.043.092.092 0 01-.044.123l-.626.298a.095.095 0 01-.126-.043zM71.296 81.936s.266.542-.573 1.896l-.626-.375s.446-.912 1.199-1.52zM72.734 82.253a3.719 3.719 0 01-.81-.66.13.13 0 01.009-.185.134.134 0 01.187.008c1.07 1.15 2.356 1.061 2.37 1.06a.132.132 0 01.142.12.131.131 0 01-.121.14c-.045.004-.871.061-1.777-.483z",
  fill: "#013B4C"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M75.112 81.66l-3.11-.925a.248.248 0 01-.168-.31l.198-.647a.254.254 0 01.316-.166l3.109.925c.134.04.21.179.169.31l-.199.647a.254.254 0 01-.316.166z",
  fill: "#027A9A"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.293 57.225h13.854l4.084-9.991a.149.149 0 00-.14-.204H70.734a.374.374 0 00-.347.23l-4.094 9.965z",
  fill: "#013B4A"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.313 56.827h-18.14a.306.306 0 00-.31.304c0 .167.139.303.31.303h17.684a.379.379 0 00.368-.278l.088-.329z",
  fill: "#02637D"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.211 31.21s1.07 1.414 1.335 2.223c.456 1.39.253 2.393-.102 3.075 0 0 2.155-3.1 1.274-4.765-.934-1.766-2.507-.533-2.507-.533z",
  fill: "#31333E"
}), React.createElement("path", {
  d: "M76.576 51.697c-.004.198-.034.372-.192.49-.193.145-.437.043-.442-.2a.83.83 0 01.092-.41c.136-.24.4-.182.542.12z",
  fill: "#02637D"
}), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_4950_6652",
  x1: "31.058",
  y1: "77.681",
  x2: "27.058",
  y2: "85.517",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "paint1_linear_4950_6652",
  x1: "23.429",
  y1: "66.344",
  x2: "28.633",
  y2: "79.042",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#38A841"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#7DDF84"
})), React.createElement("linearGradient", {
  id: "paint2_linear_4950_6652",
  x1: "23.088",
  y1: "72.582",
  x2: "27.72",
  y2: "75.91",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#8EE794"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#3FAD48"
})), React.createElement("linearGradient", {
  id: "paint3_linear_4950_6652",
  x1: "23.709",
  y1: "67.529",
  x2: "28.589",
  y2: "79.601",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#94E69A"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#3DAC46"
})), React.createElement("linearGradient", {
  id: "paint4_linear_4950_6652",
  x1: "30.373",
  y1: "58.329",
  x2: "30.663",
  y2: "78.975",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#94E69A"
}), React.createElement("stop", {
  offset: "0",
  stopColor: "#8CEC93"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#38A841"
})), React.createElement("linearGradient", {
  id: "paint5_linear_4950_6652",
  x1: "30.136",
  y1: "60.297",
  x2: "30.312",
  y2: "79.21",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#94E699"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#87E09F"
})), React.createElement("linearGradient", {
  id: "paint6_linear_4950_6652",
  x1: "30.652",
  y1: "77.521",
  x2: "26.223",
  y2: "85.968",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
})), React.createElement("linearGradient", {
  id: "paint7_linear_4950_6652",
  x1: "76.536",
  y1: "62.201",
  x2: "76.536",
  y2: "80.421",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#026D89"
}), React.createElement("stop", {
  offset: ".986",
  stopColor: "#01475B"
})), React.createElement("linearGradient", {
  id: "paint8_linear_4950_6652",
  x1: "55.858",
  y1: "59.073",
  x2: "90.013",
  y2: "76.706",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0386A9"
}), React.createElement("stop", {
  offset: "1",
  stopColor: "#013A4A"
})), React.createElement("linearGradient", {
  id: "paint9_linear_4950_6652",
  x1: "62.067",
  y1: "39.23",
  x2: "64.117",
  y2: "53.155",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#21CBF0"
}), React.createElement("stop", {
  offset: ".527",
  stopColor: "#00A8CD"
}), React.createElement("stop", {
  offset: ".944",
  stopColor: "#0298C0"
})), React.createElement("linearGradient", {
  id: "paint10_linear_4950_6652",
  x1: "75.323",
  y1: "65.859",
  x2: "75.323",
  y2: "81.212",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#02546A"
}), React.createElement("stop", {
  offset: ".965",
  stopColor: "#013D4D"
})), React.createElement("linearGradient", {
  id: "paint11_linear_4950_6652",
  x1: "68.31",
  y1: "39.601",
  x2: "68.31",
  y2: "54.892",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#14BDE2"
}), React.createElement("stop", {
  offset: ".944",
  stopColor: "#0298C0"
})), React.createElement("linearGradient", {
  id: "paint12_linear_4950_6652",
  x1: "56.799",
  y1: "39.23",
  x2: "56.799",
  y2: "57.078",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#14BDE2"
}), React.createElement("stop", {
  offset: ".944",
  stopColor: "#0298C0"
})))));